import React, {useCallback} from 'react';
import {
    Dialog,
    Button,
    Flex,
    PriorityIcon,
    DialogTitle
} from '@priority-software/priority-style-react';
import texts from '../../texts';

type Props = {
    onClose: () => void;
    isOpen: boolean;
    onApprove: () => void;
};

export const FormChangeAlert = ({onClose, isOpen, onApprove}: Props) => {
    const onApproveClick = useCallback(() => {
        onClose();
        onApprove();
    }, [onClose, onApprove]);

    return isOpen ? (
        <Dialog
            zIndex={11000}
            isOpen={isOpen}
            width={320}
            onClose={onClose}
            title={
                <DialogTitle
                    icon={PriorityIcon.questionCircle}
                    skin="text"
                    title={texts.save_data_warn}
                />
            }
            footer={
                <Flex>
                    <Button onClick={onApproveClick} skin="primary" autoFocus>
                        {texts.save_data_yes}
                    </Button>
                    <Button onClick={onClose} skin="secondary">
                        {texts.save_data_no}
                    </Button>
                </Flex>
            }
        />
    ) : null;
};
